import { useCallback, useEffect, useRef, useState } from "react";
import { getSignalRConnection } from "../../../utils/signalRConnection";
import { UserDTO } from "../../../apiclients/bstinsights";

export function useInvitationQueue() {
  const [queue, setQueue] = useState<number[]>([]);
  const [showSuccess, setShowSuccess] = useState(false);

  const queueRef = useRef<number[]>(queue);
  useEffect(() => {
    queueRef.current = queue;
  }, [queue]);

  const enqueueInvitedUsers = useCallback((users: number[]) => {
    setQueue((prev) => [...prev, ...users]);
  }, []);

  useEffect(() => {
    const conn = getSignalRConnection();

    const handler = (userId: number, updatedFields: UserDTO) => {
      if (!queueRef.current.includes(userId)) return;

      if (updatedFields.accountStatusName && updatedFields.accountStatusName === "Invitation Sent") {
        setQueue((prevQueue) => {
          const newQueue = prevQueue.filter((id) => id !== userId);
          if (newQueue.length === 0) {
            setShowSuccess(true);
            setTimeout(() => setShowSuccess(false), 3000);
          }
          return newQueue;
        });
      };
    };

    conn.on("NotifyUserUpdated", handler);

    return () => {
      conn.off("NotifyUserUpdated", handler);
    };
  }, []);

  return { enqueueInvitedHandles: enqueueInvitedUsers, showSuccess, queue };
}